// AddWorkInstruction.tsx
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Search } from "lucide-react";
import BottomNav from "../../components/BottomNav.tsx";
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";

const AddWorkInstruction: React.FC = () => {
  const { vehicleModelId, workStationId } = useParams<{ vehicleModelId: string; workStationId: string }>();
  const [description, setDescription] = useState("");
  const [fileData, setFileData] = useState<string>("");
  // You might choose to prefill modelName if you have that data; for now we let the user enter it.
  const [modelName, setModelName] = useState("");
  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFileData(reader.result as string);
      };
      reader.readAsDataURL(file); // convert file to base64 string
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const payload = {
      description,
      file: fileData,
      model_name: modelName,
      vehicle_model_id: Number(vehicleModelId),
      work_station_id: Number(workStationId),
    };

    try {
      const response = await fetch("http://172.16.101.250:4500/api/work_instruction", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error("Failed to add work instruction");
      }
      console.log("Work instruction added successfully");
      // Navigate to a final page or home page when done.
      navigate("/");
    } catch (error) {
      console.error("Error adding work instruction:", error);
    }
  };

  return (
    <div className="min-h-screen bg-blue-900 ">
      {/* Header */}
      <div className="p-4 "><img src={digitalOceanImageUrl("new%20logos/Asset%204.png")} alt="KMC Logo" className="w-16 h-auto ml-auto h-24 w-27 " />  </div>
      <div className="p-6 flex justify-between items-center">
        <h1 className="text-white text-lg font-bold">
          Workstation Creation
        </h1>
      </div>

      {/* Search Bar */}
      <div className="px-6 mb-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Search for an instruction document..."
            className="w-full py-3 px-4 pr-10 rounded-full"
          />
          <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
      </div>
      <div className="bg-white rounded-3xl h-screen" >
      <div className=" mb-6 bg-white rounded-full p-6">
      <div className="bg-white rounded-xl border p-8 flex justify-between items-center">
          <div>
            <h2 className="text-blue-900 text-xl font-bold mb-2">Add Work Instructions</h2>
            <p className="text-gray-600 text-sm max-w-xs">
             Work instructions for the particular Workstations in the selected building are added here. 
             Add model name and a description of the work instruction. Upload a PDF file with the work instruction details.
            </p>
          </div>
          <img src={digitalOceanImageUrl("assets/images/machineimage.jpg")} alt="12M EVS" className="w-27 h-24" />
        </div>
      </div>
      <div className="bg-white px-8 rounded-lg w-full">
        <h1 className="text-2xl font-bold mb-4">Add Work Instruction</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={modelName}
            onChange={(e) => setModelName(e.target.value)}
            placeholder="Model Name"
            className="w-full p-2 border rounded mb-4"
            required
          />
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description"
            className="w-full p-2 border rounded mb-4"
            required
          />
          <label className="block mb-4">
            Upload PDF:
            <input
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              className="mt-2"
              required
            />
          </label>
          <button
            type="submit"
            className="bg-blue-900 text-white px-4 py-2 rounded-3xl hover:bg-blue-800 w-full"
          >
            Save Work Instruction
          </button>
        </form>
      </div>
      
      </div>
      <BottomNav showBack={true} />
    </div>
  );
};

export default AddWorkInstruction;
